<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.reports }}
							</h6>
							<div class="element-box-tp">
								<a v-on:click="createReportForm" class="mr-2 mb-2 btn btn-outline-primary"><i class="icon-plus"></i> {{ t.create_report }}</a>
								<div v-if="status > 0">
									<div class="alert alert-danger" v-if="status == 403">
										{{ t.error.access_denied_content }}
									</div>
									<div class="alert alert-danger" v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</div>
								</div>
								<table-component
										v-if="status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="reports"
										sort-by="id"
										sort-order="desc"
								>
									<template>
										<table-column show="id" label="#"></table-column>
										<table-column>
											<template slot-scope="row">
												<router-link :to="{ name: 'report_present', params: { id: row.id } }" v-if="row.name">
													{{ row.name | slimiter(9) }}
												</router-link>
											</template>
										</table-column>
										<table-column cell-class="text-center">
											<template slot-scope="row">
												{{ t.report_types[row.type.key] }}
											</template>
										</table-column>
										<table-column label="period" cell-class="text-right">
											<template slot-scope="row">
												{{ _df(row.from) }} - {{ _df(row.to) }}
											</template>
										</table-column>
										<table-column :label="t.creator" cell-class="text-right">
											<template slot-scope="row">
												<router-link :to="{ name: 'userprofile', params: { id: row.created_by.id } }">
													@{{ row.created_by.username }}
												</router-link>
											</template>
										</table-column>
										<table-column :label="t.created_at" cell-class="text-right">
											<template slot-scope="row">
												{{ dateTimeFormat(row.created_at) }}
											</template>
										</table-column>
										<table-column cell-class="w50 text-center">
											<template slot-scope="row">
												<cloader v-if="row.is_preparing" class="r-loader" />
												<a target="_blank" :href="a+'api/v1/report/'+row.id+'.html?access_token='+ac" v-if="!row.is_preparing">
													<i class="icon-magnifier"></i>
												</a>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
							<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">
							<filterGenerator v-if="filter" :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="cf" v-on:close="closeReportForm">

			<div class="element-wrapper text-left">

				<h6 class="element-header capitalize">
					{{ t.create_report }}
				</h6>
				<div class="element-box-tp">
					<startFrom />
				</div>
			</div>
		</sweet-modal>
	</div>
</template>

<script>

    import filterGenerator from '@/components/form/filter'
	import ReportFrom from '@/components/reports/form/reportForm'
    import startFrom from '@/components/reports/startReport'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'reportsList',
	    components: {ReportFrom, startFrom, TableComponent, TableColumn, filterGenerator},
        data () {
            return {
                a: window.api,
	            ac: window.auth.accessToken,
                t: this.$root.t,
	            type: null,
	            reports: [],
                pagination: null,
                isLoading: false,
	            status: 0,
	            filter: null
            }
        },
        watch: {
            '$route.query' () {
                this.fetchReports();
            },
	        'type' () {
                this.setFilter()
	        }
        },
	    mounted () {
            this.fetchReportType()
            this.setFilter()
            this.fetchReports()
        },
	    methods: {
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });

                window.scroll(0, 0);
            },
            fetchReports () {
                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/reports',
                        { params: this.$route.query })
                        .then(response => {

	                    this.pagination = response.body.result.pagination;
	                    this.reports =  Object.values(response.body.result.reports);
	                    this.status = response.status;

	                    this.isLoading = false;
                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
                }
            },
            closeReportForm () {
                this.$router.replace({ params: {id: null} });
                this.fetchReports()
                setTimeout( () => {
                    window.document.body.style.overflow = 'auto';
                }, 500);
            },
		    createReportForm () {
				this.$refs.cf.open()
		    },
            fetchReportType () {

                this.$http.get(api+'api/v1/get/all_report_types').then(response => {
                    // get body data
                    this.type = response.body.result.type;
	                this.isLoading = false;
	                this.status = response.status;
                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            filterNow: function() {
                this.pagination = null
                this.filter.model.page = 1;
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            setFilter () {

                this.filter = {
                    model: {
                        uid: '',
                        type: [],
                        createdAt: [],
                        page: 1
                    },
                    schema: {
                        groups: [
                            {
                                legend: '',
                                fields: [
                                    {
                                        type: "checklist",
                                        label: this.t.report_type,
                                        model: "type",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.type,
                                        checklistOptions: {
                                            value: "id",
                                            name: "name"
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.time_range,
                                        model: "createdAt",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.users,
                                        model: "user",
                                        multi: true,
                                        onlyId: true,
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.filterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/list.vue